import i18n from "i18next"

export const SESSION_EXPIRED_KEY = "auth.sessionExpired"

const SESSION_EXPIRED_FALLBACK =
  "Your session has expired. Please sign in again."

// Imported straight from i18next rather than ../../../i18n: that module runs
// `.use(initReactI18next)` on import, which the auth store must not pull in.
export const sessionExpiredMessage = (): string =>
  i18n.isInitialized ? i18n.t(SESSION_EXPIRED_KEY) : SESSION_EXPIRED_FALLBACK
